var _g, _path, _g2, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 90,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#connect_svg__filter0_dd_1153_56910)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 13,
    width: 40,
    height: 40,
    rx: 8,
    fill: "url(#connect_svg__paint0_linear_1153_56910)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#connect_svg__clip0_1153_56910)",
    filter: "url(#connect_svg__filter1_d_1153_56910)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176 46a12.997 12.997 0 01-12.01-8.025 12.996 12.996 0 012.818-14.167 12.998 12.998 0 0120.001 1.97 12.996 12.996 0 01-1.617 16.414A12.999 12.999 0 01176 46zm11.917-13a11.912 11.912 0 00-7.357-11.01A11.916 11.916 0 10187.917 33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.083 40.258a.543.543 0 01-.525-.422.536.536 0 01.041-.354c.053-.11.141-.2.252-.253a18.845 18.845 0 014.252-1.479v-1.83a3.532 3.532 0 01-1.436-2.78 1.53 1.53 0 01-.606-1.343 1.616 1.616 0 01.498-1.273c-.244-.86-.645-2.388.087-3.174a1.477 1.477 0 011.251-.433 4.99 4.99 0 014.831-1.75c1.625.266 2.828 1.132 3.099 2.2.271 1.067-.119 2.432-.358 3.168a1.63 1.63 0 01.488 1.262 1.53 1.53 0 01-.607 1.343 3.533 3.533 0 01-1.419 2.78v1.83c1.446.316 2.85.801 4.182 1.447a.538.538 0 01.277.31.536.536 0 01-.023.415.546.546 0 01-.52.308.55.55 0 01-.206-.053 16.936 16.936 0 00-4.333-1.44.545.545 0 01-.46-.543v-2.583a.539.539 0 01.33-.499c.038 0 1.083-.541 1.083-2.361a.546.546 0 01.499-.542.84.84 0 00.092-.412.837.837 0 00-.06-.422.54.54 0 01-.498-.542c.021-.186.069-.368.141-.541.184-.58.541-1.783.357-2.638-.157-.623-1.083-1.208-2.226-1.392a3.852 3.852 0 00-3.943 1.554.548.548 0 01-.542.239c-.173-.038-.482-.076-.601.054-.228.243-.163.985.178 2.215.053.165.084.336.093.51a.542.542 0 01-.499.54.839.839 0 00-.092.418.817.817 0 00.092.412.54.54 0 01.499.541c0 1.831 1.083 2.346 1.11 2.367a.537.537 0 01.325.493V38.2a.542.542 0 01-.46.542c-1.53.286-3.014.78-4.41 1.468a.507.507 0 01-.233.048z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356 33H196",
    stroke: "#F4F5F7",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#connect_svg__filter2_dd_1153_56910)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 13,
    width: 40,
    height: 40,
    rx: 8,
    fill: "url(#connect_svg__paint1_linear_1153_56910)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#connect_svg__clip1_1153_56910)",
    filter: "url(#connect_svg__filter3_d_1153_56910)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.501 41.157l-3.913-2.259v1.353H378v1.812h6.588v1.353l3.913-2.259zM364.406 37.08a4.99 4.99 0 004.984 4.984h1.36v-1.812h-1.36a3.175 3.175 0 01-3.171-3.172 3.175 3.175 0 013.171-3.172h1.36v-1.812h-1.36a4.99 4.99 0 00-4.984 4.984zM384.343 28.924a4.99 4.99 0 00-4.984-4.985H378v1.813h1.359a3.175 3.175 0 013.172 3.172 3.175 3.175 0 01-3.172 3.171H378v1.813h1.359a4.99 4.99 0 004.984-4.984zM370.75 23.94h-7.25v1.812h7.25v-1.813zM377.093 22.127h-5.437v5.437h5.437v-5.437zM377.093 30.283h-5.437v5.437h5.437v-5.437zM377.093 38.44h-5.437v5.437h5.437v-5.438z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M290 33h-78",
    stroke: "url(#connect_svg__paint2_linear_1153_56910)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "connect_svg__filter0_dd_1153_56910",
    x: 131,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1153_56910"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1153_56910",
    result: "effect2_dropShadow_1153_56910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1153_56910",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "connect_svg__filter1_d_1153_56910",
    x: 159,
    y: 17,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1153_56910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1153_56910",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "connect_svg__filter2_dd_1153_56910",
    x: 331,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1153_56910"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.215686 0 0 0 0 0.254902 0 0 0 0 0.317647 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1153_56910",
    result: "effect2_dropShadow_1153_56910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1153_56910",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "connect_svg__filter3_d_1153_56910",
    x: 359.5,
    y: 17.5,
    width: 33,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1153_56910"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1153_56910",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "connect_svg__paint0_linear_1153_56910",
    x1: 176,
    y1: 13,
    x2: 176,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E94242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C81414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "connect_svg__paint1_linear_1153_56910",
    x1: 376,
    y1: 13,
    x2: 376,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D4DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C727F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "connect_svg__paint2_linear_1153_56910",
    x1: 291.592,
    y1: 31.5,
    x2: 210.408,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E01E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E01E5A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "connect_svg__clip0_1153_56910"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(163 20)",
    d: "M0 0h26v26H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "connect_svg__clip1_1153_56910"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(363.5 20.5)",
    d: "M0 0h25v25H0z"
  })))));
}
export default SvgConnect;